import commaSeparator from './commaSeparator';
function removeExtraDecimals(number, validDecimals) {
  return parseFloat(number.toFixed(validDecimals));
}
function thousandsSeparator(price) {
  return "$".concat(commaSeparator(price));
}
function valueRollUp(price, opts) {
  const _ref = opts !== null && opts !== void 0 ? opts : {},
    _ref$kDecimalPlaces = _ref.kDecimalPlaces,
    kDecimalPlaces = _ref$kDecimalPlaces === void 0 ? 3 : _ref$kDecimalPlaces,
    _ref$mDecimalPlaces = _ref.mDecimalPlaces,
    mDecimalPlaces = _ref$mDecimalPlaces === void 0 ? 6 : _ref$mDecimalPlaces;
  let formattedPrice = '$';
  if (price < 1000) {
    formattedPrice += price;
  } else if (price < 1000000) {
    formattedPrice += "".concat(removeExtraDecimals(price / 1000, kDecimalPlaces), "k");
  } else {
    formattedPrice += "".concat(removeExtraDecimals(price / 1000000, mDecimalPlaces), "m");
  }
  return formattedPrice;
}
export default {
  removeExtraDecimals,
  thousandsSeparator,
  valueRollUp
};